import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from '../react-queries/mutations';

const Wrapper = styled.div`
  padding: 20px;
`;

const LogoutButton = styled.button`
  width: 100%;
  padding: 14px 0;
  background: #ff4d4d;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  margin-top: 20px;
  cursor: pointer;

  &:hover {
    background: #ff3333;
  }
`;

const MypagePage: React.FC = () => {
  const navigate = useNavigate();
  const { mutate: logout, isPending } = useLogoutMutation();

  const handleLogout = () => {
    if (window.confirm('로그아웃 하시겠습니까?')) {
      logout(undefined, {
        onSuccess: () => {
        
          navigate('/login');
        },
        onError: (error: Error) => {
          alert('로그아웃 실패: ' + error.message);
        }
      });
    }
  };

  return (
    <Wrapper>
      <LogoutButton 
        onClick={handleLogout}
        disabled={isPending}
      >
        {isPending ? '로그아웃 중...' : '로그아웃'}
      </LogoutButton>
    </Wrapper>
  );
};

export default MypagePage; 